module.exports = __webpack_public_path__ + "static/media/phone.69a5d83d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustrations/phone.svg
// module id = 301
// module chunks = 0